let injectHighlight = (graph) => {
    let injectHighlightObj = {
        // 从外到内的点亮
        async setHighlightStep(d) {
            this.lockTimer = setTimeout(this.setLock, 1000, d); // lock图层亮起
            this.highlightNode = d;

            let nodes = [d];
            let links = [];
            this.findLinkedRoute(d, 'target', Infinity, nodes, links);
            nodes = nodes.reverse();
            links = links.reverse();

            for (let i = 0; i < nodes.length; i++) {
                let lightNode = nodes.slice(0, i + 1);
                let lightLink = links.slice(0, i);
                console.log(this, i, 'setHighlightStep');
                if (this) {
                    this.pureHighlight(lightNode, lightLink);
                    await this.$sleep(1000);
                    if (this.isStop) {
                        return void 0;
                    }
                }
            }

        },
        setHighlight(d, isForce = false) {
            if (!d) {
                return void 0;
            }
            if (this.isDrag) {
                console.log('is dragging not setHighlight', d.name);
                return void 0;
            }
            this.nodesGroup.style('z-index', _ => {
                if (_.id === d.id) {
                    return 10;
                } else {
                    return 1;
                }
            });
            this.lockTimer = setTimeout(this.setLock, 1000, d);
            this.highlightNode = d;

            if (this.option.customSetHighLight) {
                this.option.customSetHighLight(d, isForce);
            } else {
                let nodeArr = [d]; // 高亮的节点
                let linkArr = []; // 高亮的线

                this.findLinkedRoute(d, 'source', 1, nodeArr, linkArr); // 向子节点找几层
                this.findLinkedRoute(d, 'target', 1, nodeArr, linkArr); // 向父节点找几层

                this.pureHighlight(nodeArr, linkArr);
            }
        },
        resetHighlight(d, isForce = false) {
            if (!d) {
                return void 0;
            }
            if (this.isDrag) {
                console.log('is dragging not resetHighlight', d.name);
                return void 0;
            }
            this.nodesGroup.style('z-index');
            this.highlightNode = null;
            clearTimeout(this.lockTimer);
            this.pureHighlight();
        },
        // nodes, links 不存在即取消所有的隐藏 // TODO 逻辑考虑合并 优化class就好了
        pureHighlight(nodes, links) {
            if (!nodes && !links) {
                this.nodesGroup.classed('kg-force-node-wrap-opacity', false)
                    .classed('kg-force-node-wrap-full', false);
                this.linksGroup.classed('kg-force-link-opacity', false)
                    .classed('kg-force-link-full', false);
                this.setLock();
            } else {
                this.nodesGroup.classed('kg-force-node-wrap-opacity', node => !nodes.includes(node))
                    .classed('kg-force-node-wrap-full', node => nodes.includes(node));
                this.linksGroup.classed('kg-force-link-opacity', link => !links.includes(link))
                    .classed('kg-force-link-full', link => links.includes(link));
            }
        },
        // 遍历连接的节点 TODO 值算一次 这个方法暂时不用
        isConnected(a, b) {
            let linkedByIndex = {};
            this.data.links.forEach(function (d) {
                linkedByIndex[d.source + ',' + d.target] = true;
            });

            return linkedByIndex[a.id + ',' + b.id] || linkedByIndex[b.id + ',' + a.id] || a.id === b.id;
        },
        // TODO 整合
        light() {
            this.nodesGroup.classed('kg-force-node-wrap-opacity', false);
            this.linksGroup.classed('kg-force-link-opacity', false);
        },

        dark() {
            this.nodesGroup.classed('kg-force-node-wrap-full', false).classed('kg-force-node-wrap-opacity', true);
            this.linksGroup.classed('kg-force-link-full', false).classed('kg-force-link-opacity', true);
        },
    };

    graph.inject(injectHighlightObj);
};

export default injectHighlight;
